var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconXThin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.47 3.47a.75.75 0 0 1 1.06 0L16 14.94 27.47 3.47a.75.75 0 1 1 1.06 1.06L17.06 16l11.47 11.47a.75.75 0 1 1-1.06 1.06L16 17.06 4.53 28.53a.75.75 0 0 1-1.06-1.06L14.94 16 3.47 4.53a.75.75 0 0 1 0-1.06",
  clipRule: "evenodd"
})));
export default SvgIconXThin;